import { Helmet } from 'react-helmet-async';

import { Grid } from '@mui/material';
import PositionsData, { ScheduleActivitySource } from './activitylogsData';

function Roles({ dataSource }: { dataSource?: ScheduleActivitySource }) {
  return (
    <>
      <Helmet>
        <title>Dashboard - Jobs</title>
      </Helmet>
      {/* <PageTitleWrapper>
        < JobsHeader/>
      </PageTitleWrapper> */}
      {/* <Container> */}
      <Grid
        // container
        // direction="row"
        // justifyContent="center"
        // alignItems="stretch"
        // spacing={3}
             >
        <Grid item xs={12}>
          <PositionsData dataSource={dataSource} />
        </Grid>
      </Grid>
      {/* </Container> */}
      {/* <Footer /> */}
    </>
  );
}

export default Roles;
